import { Fragment, useEffect, useState } from "react";
import { Text, Avatar, DataList } from "@radix-ui/themes";
import Badge from "@/components/atoms/Badge";
import Button from "@/components/atoms/Button";
import { PenSquare, X } from "lucide-react";
import Container from "@/components/atoms/Container";
import useMessageProps from "@/hooks/useMessageProps";
import Notice from "@/types/Notice";
import useAccess from "@/hooks/useAccess";
import * as Constants from "@/constants";
import StandardBreadcrumb from "@/components/molecules/StandardBreadcrumb";
import { router } from "@inertiajs/react";
import NoticeForm from "@/components/organisms/Notice/Form";

type Props = {
  notice: Notice;
  [key: string]: any;
};

const Show = ({ notice, ...props }: Props) => {
  const [edit, setEdit] = useState(false);
  const [isActionTab, setIsActionTab] = useState(true);
  const { getAccess } = useAccess();
  const breadcrumbItems = [
    {
      label: "Notices",
      onClick: () => router.get("/notices"),
    },
    {
      label: notice.id.toString(),
    },
  ];

  useMessageProps(props);

  const onSubmit = (data: Notice) => {
    if (!edit) return;

    router.put(`/notices/${notice.id}`, data, {
      onFinish: () => setEdit(false),
    });
  };

  return (
    <div>
      <Container>
        <StandardBreadcrumb items={breadcrumbItems} />
        <div className="flex items-center justify-between pt-2">
          <div className="flex items-center gap-2">
            <DataList.Root orientation="vertical" className="!flex-row !gap-6">
              <DataList.Item>
                <DataList.Label>Status</DataList.Label>
                <DataList.Value>
                  <Badge
                    variant={
                      notice.notice_active
                        ? "success"
                        : "destructive"
                    }
                  >
                    {notice.notice_active ? "Active" : "Inactive"}
                  </Badge>
                </DataList.Value>
              </DataList.Item>
              <DataList.Item>
                <DataList.Label>Client Visibility</DataList.Label>
                <DataList.Value>
                  <Badge
                    variant={
                      notice.hide_from_client
                        ? "destructive"
                        : "success"
                    }
                  >
                    {notice.hide_from_client ? "Invisible" : "Visible"}
                  </Badge>
                </DataList.Value>
              </DataList.Item>
            </DataList.Root>
          </div>
          <div>
            <Button
              onClick={() => setEdit(!edit)}
              disabled={!getAccess(["update_account"])}
            >
              {edit ? (
                <>
                  <X size={16} className="mr-2" /> <span>Cancel</span>
                </>
              ) : (
                <>
                  <PenSquare size={16} className="mr-2" />
                  <span>Edit</span>
                </>
              )}
            </Button>
          </div>
        </div>
 
      </Container>

      <Container className="py-4">
        <NoticeForm
          edit={edit}
          notice={notice}
          onSubmit={onSubmit}
          errors={props?.redirect_props?.errors}
        />
      </Container>
      

    </div>
  );
};

export default Show;
